import { render, staticRenderFns } from "./dialog-alert-evaluation.vue?vue&type=template&id=2574a496&"
import script from "./dialog-alert-evaluation.vue?vue&type=script&lang=js&"
export * from "./dialog-alert-evaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports